export const homeConstants = {
  limitPage: 4,
};
